import { createContext, useContext, useState, type ReactNode } from "react";
import { createPortal } from "react-dom";

const ActionsTarget = createContext<HTMLElement | null | undefined>(undefined);
/** The action slot belongs after the scrolling content/footer. Fields remain
 * in their original forms; submit buttons explicitly name their form owner. */
export function ActionsFrame({ children, className, label }: { children: ReactNode; className: string; label?: string }) {
  const [target, setTarget] = useState<HTMLElement | null>(null);
  // A `label` makes the slot a named region landmark. Its content is portalled
  // outside <main>, so without one a link action (axe exempts buttons) sits in
  // no landmark at all and screen-reader landmark navigation never reaches it.
  const slot = label === undefined
    ? <div className={className} ref={setTarget} />
    : <section className={className} aria-label={label} ref={setTarget} />;
  return <ActionsTarget.Provider value={target}>{children}{slot}</ActionsTarget.Provider>;
}
export function PageActions({ children, className = "w2-foot" }: { children: ReactNode; className?: string }) {
  const target = useContext(ActionsTarget);
  if (target === null || children === null || children === undefined || children === false) return null;
  const content = <div className={className}>{children}</div>;
  return target ? createPortal(content, target) : content;
}
